var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.dynamicComponent,_vm._g(_vm._b({tag:"component",attrs:{"label":_vm.translatedLabel,"rules":_vm.computedRules,"type":_vm.type}},'component',_vm.dynamicComponentProps,false),_vm.dynamicComponentListeners))}
var staticRenderFns = []

export { render, staticRenderFns }